import React from 'react';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const OptionsScriptsIndicator = ({optionsScripts}) => (
    optionsScripts && optionsScripts.length > 0 ? (
        <span>
            <FontAwesomeIcon icon="filter" />
        </span>
    ) : null
);

OptionsScriptsIndicator.propTypes = {
    optionsScripts: PropTypes.array,
};

export default OptionsScriptsIndicator;
